import { useEffect, useState } from 'react';
import { initView } from 'dingtalk-docs-cool-app';
import { Button, Card, Input } from 'dingtalk-design-desktop';
import './style.css';

const CONFIG_STORAGE_KEY = 'datasource-plugin-config';

type Config = {
  appid: string;
  api: string;
  mime: string;
  method: string;
  content: string;
};

function readStoredConfig(): Partial<Config> {
  try {
    return JSON.parse(localStorage.getItem(CONFIG_STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
}

function applyConfig(
  saved: Partial<Config> | undefined,
  setters: {
    setAppid: (v: string) => void;
    setApi: (v: string) => void;
    setMime: (v: string) => void;
    setMethod: (v: string) => void;
    setContent: (v: string) => void;
  }
) {
  if (!saved) {
    return;
  }

  if (saved.appid != null) setters.setAppid(String(saved.appid));
  if (saved.api != null) setters.setApi(String(saved.api));
  if (saved.mime != null) setters.setMime(String(saved.mime));
  if (saved.method != null) setters.setMethod(String(saved.method));
  if (saved.content != null) setters.setContent(String(saved.content));
}

function App() {
  const [initial] = useState(readStoredConfig);
  const [appid, setAppid] = useState(() => String(initial.appid || ''));
  const [api, setApi] = useState(() => String(initial.api || ''));
  const [mime, setMime] = useState(() => String(initial.mime || ''));
  const [method, setMethod] = useState(() => String(initial.method || ''));
  const [content, setContent] = useState(() => String(initial.content || ''));

  const setters = { setAppid, setApi, setMime, setMethod, setContent };

  useEffect(() => {
    const loadConfig = () => {
      applyConfig(readStoredConfig(), setters);
    };

    initView({
      onReady: loadConfig
    });

    loadConfig();

    const handlePageShow = () => {
      loadConfig();
    };

    window.addEventListener('pageshow', handlePageShow);

    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, []);

  const goNext = async () => {
    const config = {
      appid,
      api,
      mime,
      method,
      content
    };
    localStorage.setItem(CONFIG_STORAGE_KEY, JSON.stringify(config));
    await Dingdocs.base.host.saveConfigAndGoNext(config);
  };

  return (
    <div className="page">
      <div className="content">
        <Card size="small">
          <div className="form-item">
            <label>appid</label>
            <Input value={appid} onChange={e => setAppid(e.target.value)} />
          </div>
          <div className="form-item">
            <label>api</label>
            <Input value={api} onChange={e => setApi(e.target.value)} />
          </div>
          <div className="form-item">
            <label>mime</label>
            <Input value={mime} onChange={e => setMime(e.target.value)} />
          </div>
          <div className="form-item">
            <label>method</label>
            <Input value={method} onChange={e => setMethod(e.target.value)} />
          </div>
          <div className="form-item">
            <label>content</label>
            <Input.TextArea rows={4} value={content} onChange={e => setContent(e.target.value)} />
          </div>
          <div className="form-actions">
            <Button type="primary" block onClick={goNext}>
              点击下一步
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
}

export default App;
